// sentry
import sentry from './modules/sentry.js'
// Dependencies
import { _, makeGtmCall } from './utils.js'

// class maps
import Accordion from './modules/accordion.js'
import AddToCart from './modules/add-to-cart.js'
import Basket from './modules/basket.js'
import BasketSteps from './modules/basket-steps.js'
import buttonInSearch from './modules/button-in-search.js'
import CheckboxToggle from './modules/checkbox-toggle.js'
import EntranceTransition from './modules/entrance-transitions.js'
import FormPost from './modules/form-post.js'
import FormValidate from './modules/form-validate.js'
import HolidayPayCalculator from './modules/holiday-pay-calculator.js'
import inPageSearch from './modules/in-page-search.js'
import LazyLoad from './modules/lazy-load.js'
import Listing from './modules/listing.js'
import Loading from './modules/loading.js'
import ObjectFit from './modules/object-fit.js'
import PasswordReveal from './modules/password-reveal.js'
import PcaLookup from './modules/pca-lookup.js'
import Quiz from './modules/quiz.js'
import QuizResults from './modules/quiz-results.js'
import RadioToggle from './modules/radio-toggle.js'
import SelectUrl from './modules/select-url.js'
import Steps from './modules/steps.js'
import TableListing from './modules/table-listing.js'
import ToggleSelect from './modules/toggle-select.js'
import Tooltip from './modules/tooltip.js'
import Video from './modules/video.js'
import tracking from './modules/tracking.js'
import gatedContent from './modules/gated-content.js'
import CmRenewalForm from './modules/cm-renewal-form.js'

// doc events
import Menu from './modules/menu.js'
import Modal from './modules/modal.js'
import Slider from './modules/slider.js'
import Tabs from './modules/tabs.js'
import ToggleClass from './modules/toggle-class.js'
import CrmConnectionCheck from './modules/crm-connection-check.js'

// Third Party
import './modules/reciteme.js'

sentry()

gatedContent()

new Menu()
new Modal()
new Tabs()
new ToggleClass()

// prettier-ignore
{
    _('', 'entrance').nodes().map((el) => new EntranceTransition(el))
    _('', 'validate').nodes().map((el) => new FormValidate(el))
    _('accordion', 'element').nodes().map((el) => new Accordion(el))
    _('add-to-cart').nodes().map((el) => new AddToCart(el))
    _('basket', 'element').nodes().map((el) => new Basket(el))
    _('basket-steps').nodes().map((el) => new BasketSteps(el))
    _('button-in-search', 'element').nodes().map((el) => buttonInSearch(el))
    _('fieldset', 'element').nodes().map((el) => new CheckboxToggle(el))
    _('form-post').nodes().map((el) => new FormPost(el))
    _('gtm-click').nodes().map((el) => {
        el.addEventListener('click', () => {
            makeGtmCall(el)
        })
    })
    _('gtm-focus').nodes().map((el) => {
        el.addEventListener('focus', () => {
            makeGtmCall(el)
        })
    })
    _('holiday-pay-calculator').nodes().map((el) => new HolidayPayCalculator(el))
    _('image', 'lazyload').nodes().map((el) => new LazyLoad(el))
    _('in-page-search', 'element').nodes().map((el) => inPageSearch(el))
    _('listing').nodes().map((el) => new Listing(el))
    _('loading').nodes().map((el) => new Loading(el))
    _('main-steps', 'element').nodes().map((el) => new Steps(el))
    _('modal').nodes().map((el) => new CrmConnectionCheck(el))
    _('object-fit-contain', 'polyfill').nodes().map((el) => new ObjectFit(el, 'contain'))
    _('object-fit-cover', 'polyfill').nodes().map((el) => new ObjectFit(el, 'cover'))
    _('password-reveal').nodes().map((el) => new PasswordReveal(el))
    _('postcode-lookup', 'element').nodes().map((el) => new PcaLookup(el))
    _('quiz', 'element').nodes().map((el) => new Quiz(el))
    _('quiz-results', 'element').nodes().map((el) => new QuizResults(el))
    _('radio-toggle').nodes().map((el) => new RadioToggle(el))
    _('select-url').nodes().map((el) => new SelectUrl(el))
    _('slider').nodes().map((el) => new Slider(el))
    _('table-listing').nodes().map((el) => new TableListing(el))
    _('table-select', 'element').nodes().map((el) => new CheckboxToggle(el))
    _('toggle-select', 'element').nodes().map((el) => new ToggleSelect(el))
    _('tooltip').nodes().map((el) => new Tooltip(el))
    _('video', 'element').nodes().map((el) => new Video(el))
    _('cm-renewal-form', 'element').nodes().map((el) => new CmRenewalForm(el))
}

window.tracking = tracking()
